import { cx } from '@linaria/core';
import { option, patValue } from './SetupComputeModal.styles';

export function FormatOptionForPAT({
  pat,
  isLoading,
  className,
  mask = true,
  labelPrefix = 'PAT:',
}: {
  pat: string;
  isLoading?: boolean;
  className?: string;
  mask?: boolean;
  labelPrefix?: string;
}) {
  const patPrefix = <strong>{labelPrefix}</strong>;

  if (isLoading) {
    return <span className={cx(option, className)}> {patPrefix}Loading...</span>;
  }

  return (
    <span className={cx(option, className)}>
      {pat ? (
        <>
          {patPrefix} <span className={patValue}>{mask ? pat.slice(0, 5) + '*'.repeat(5) : pat}</span>
        </>
      ) : (
        <strong>Choose PAT</strong>
      )}
    </span>
  );
}
